import React, { useContext, useState } from "react";
import {
  BoldLink,
  BoxContainer,
  FormContainer,
  Input,
  LineText,
  SubmitButton,
} from "./common";
import { useNavigate } from "react-router-dom";
import { Marginer } from "../marginer";
import { AccountContext } from './AccountContext';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { AuthApi } from "../../../apis";

export function SignupForm(props) {
  const { switchToSignin } = useContext(AccountContext);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // Initialize formik with validation
  const formik = useFormik({
    initialValues: {
      name: '',
      email: '',
      password: '',
      type: 'User' // Default value
    },
    validationSchema: Yup.object({
      name: Yup.string()
        .required('Name is required'),
      email: Yup.string()
        .email('Invalid email address')
        .required('Email is required'),
      password: Yup.string()
        .min(6, 'Password must be at least 6 characters')
        .required('Password is required'),
      type: Yup.string()
        .oneOf(['User', 'Admin'], 'Invalid type')
        .required('Type is required'),
    }),
    onSubmit: async (values) => {
      setLoading(true);
      setError(null);
      try {
        const res = await AuthApi.Register(values);

        if (res) {
          localStorage.setItem("token", res.data.data.token);
          localStorage.setItem("user", JSON.stringify(res.data.data.user));
          if (res.data.data.user.role_id.name === "User") {
            window.location.href = "/user/time/add";
          }
          else {
            navigate('/');
          }
        } else {
          setError("Signup failed. Please check your details and try again.");
        }
      } catch (err) {
        console.error("Error occurred:", err.response ? err.response.data : err);
        setError("An error occurred. Please try again.");
      } finally {
        setLoading(false);
      }
    },
  });

  return (
    <BoxContainer style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
      <FormContainer onSubmit={formik.handleSubmit} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        <Input
          type="text"
          name="name"
          placeholder="Name"
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          value={formik.values.name}
        />
        {formik.touched.name && formik.errors.name ? (
          <div style={{ color: 'red', fontSize: '12px' }}>{formik.errors.name}</div>
        ) : null}

        <Input
          type="email"
          name="email"
          placeholder="Email"
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          value={formik.values.email}
        />
        {formik.touched.email && formik.errors.email ? (
          <div style={{ color: 'red', fontSize: '12px' }}>{formik.errors.email}</div>
        ) : null}

        <Input
          type="password"
          name="password"
          placeholder="Password"
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          value={formik.values.password}
        />
        {formik.touched.password && formik.errors.password ? (
          <div style={{ color: 'red', fontSize: '12px' }}>{formik.errors.password}</div>
        ) : null}

        <SubmitButton type="submit" disabled={loading} style={{ alignSelf: 'center', mb: 4 }}>
          {loading ? "Signing up..." : "Signup"}
        </SubmitButton>
      </FormContainer>
      <Marginer direction="vertical" margin={10} />
      <LineText style={{ textAlign: 'center' }}>
        Already have an account?{" "}
        <BoldLink onClick={switchToSignin} href="#">
          Signin
        </BoldLink>
      </LineText>
      {error && <div style={{ color: 'red', fontSize: '12px' }}>{error}</div>}
    </BoxContainer>
  );
}
